import { render, staticRenderFns } from "./ComputerEmulator.vue?vue&type=template&id=69122ced&scoped=true&"
import script from "./ComputerEmulator.vue?vue&type=script&lang=ts&"
export * from "./ComputerEmulator.vue?vue&type=script&lang=ts&"
import style0 from "./ComputerEmulator.vue?vue&type=style&index=0&id=69122ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69122ced",
  null
  
)

export default component.exports